__turbopack_context__.v({
  "bucketContainer": "EventsBucket-module-scss-module__VKgPTG__bucketContainer",
  "bucketContent": "EventsBucket-module-scss-module__VKgPTG__bucketContent",
  "cardCell": "EventsBucket-module-scss-module__VKgPTG__cardCell",
  "dayEvents": "EventsBucket-module-scss-module__VKgPTG__dayEvents",
  "dayGroup": "EventsBucket-module-scss-module__VKgPTG__dayGroup",
  "dayHeader": "EventsBucket-module-scss-module__VKgPTG__dayHeader",
  "dayHeaderAccessory": "EventsBucket-module-scss-module__VKgPTG__dayHeaderAccessory",
  "dayHeaderLabels": "EventsBucket-module-scss-module__VKgPTG__dayHeaderLabels",
  "dayIndicator": "EventsBucket-module-scss-module__VKgPTG__dayIndicator",
  "dayLine": "EventsBucket-module-scss-module__VKgPTG__dayLine",
  "dayMarker": "EventsBucket-module-scss-module__VKgPTG__dayMarker",
  "dayPrimaryLabel": "EventsBucket-module-scss-module__VKgPTG__dayPrimaryLabel",
  "daySecondaryLabel": "EventsBucket-module-scss-module__VKgPTG__daySecondaryLabel",
  "daySection": "EventsBucket-module-scss-module__VKgPTG__daySection",
  "gridDesktopContent": "EventsBucket-module-scss-module__VKgPTG__gridDesktopContent",
  "gridMobileGrouped": "EventsBucket-module-scss-module__VKgPTG__gridMobileGrouped",
  "groupedCardCell": "EventsBucket-module-scss-module__VKgPTG__groupedCardCell",
  "groupedContent": "EventsBucket-module-scss-module__VKgPTG__groupedContent",
  "mobileCalendarAccessoryRow": "EventsBucket-module-scss-module__VKgPTG__mobileCalendarAccessoryRow",
});
